import Select from "react-select";
import {useQuery} from "react-query";
import React, {useEffect, useState} from "react";
import {getAllActivities} from "Api/Query/ActivityQuery";
import {SelectOptionType} from "Model/Select/SelectOption";

interface Props {
    onChange: (newValue: SelectOptionType|null) => void,
    onActivitiesLoad?: (activities: any[]) => void,
    value?: any,
    classes?: string,
    placeholder?: string,
    filters?: {[key:string]:string|number}
    defaultActivityId?: string
}

export const ActivitySelect : React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>([])
    const [value, setValue] = useState<any>(null)

    const activitiesQuery = useQuery({
        enabled: false,
        queryKey: ['getAllActivities'],
        queryFn: () => getAllActivities(props.filters ?? {size:0}),
        onSuccess: (response: any) => {
            const activities : object[] = []
            response.data._result.items.map((item:any) => {
                activities.push({
                    label: item.name,
                    value: item.id
                })

                if(props.defaultActivityId && item.id === props.defaultActivityId) {
                    const defaultValue = {
                        label: item.name,
                        value: item.id
                    }
                    setValue(defaultValue)
                    props.onChange(defaultValue)
                }
            })
            setOptions(activities)

            if(props.onActivitiesLoad){
                props.onActivitiesLoad(response.data._result.items)
            }
        }
    })

    useEffect(() => {
        activitiesQuery.refetch()
    }, [])

    return (
        <Select
            isLoading={activitiesQuery.isRefetching|| activitiesQuery.isLoading}
            options={options}
            placeholder={props.placeholder ?? ""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={(newValue:any)=>{
                setValue(newValue)
                props.onChange(newValue)
            }}
            className={props.classes ?? ''}
            value={value}
        />
    )
}
